import React from 'react';
import css from './style.scss'
import {connect} from 'react-redux'


const _OnlineOffline=(props)=>{
  if(!props.online){
    return (
      <div className={css.offline}>
        You are currently offline. Some sections may not work.
      </div>
    )
  }else{
    return null;
  }
}
const mapOnline=(state)=>{
  return {
    online:state.ui.online
  }
}
export default connect(mapOnline)(_OnlineOffline)



// WEBPACK FOOTER //
// ./src/components/online_offline/index.js